module.exports = new __parcel__URL__("generic-empty-state.f12fdcef.svg").toString();